"use strict";

/**
 *  平台设置
 *  @module 特效属性
 */

import Vue from "@/main";

// 默认数据
const form = {
  rainShow: false, //雨天气
  snowShow: false, //雪天气
  foggyShow: false, //雾天气
  nightVisionShow: false, //夜视效果
};

// 保存提交 (存储至localStorage)
const saveSpecialEffectSettings = (data) => {
  localStorage.setItem("specialEffectSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureSpecialEffectSettings = () => {
  if (localStorage.getItem("specialEffectSettings")) {
    return JSON.parse(localStorage.getItem("specialEffectSettings"));
  } else {
    localStorage.setItem("specialEffectSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setSpecialEffect = (data, map = Vue.$GLOBAL.map) => {
  const { rainShow, snowShow, foggyShow, nightVisionShow } = data;
  // 雨天气
  Vue.$GLOBAL.rainEffect.enabled = rainShow;
  // 雪天气
  Vue.$GLOBAL.snowEffect.enabled = snowShow;
  Vue.$GLOBAL.snowCover.enabled = snowShow;
  // 雾天气
  Vue.$GLOBAL.fogEffect.enabled = foggyShow;
  // 夜视效果
  Vue.$GLOBAL.nightVisionEffect.enabled = nightVisionShow;
};

export {
  saveSpecialEffectSettings,
  exposureSpecialEffectSettings,
  setSpecialEffect,
};
